<template>
  <div class='indexbox'>
    <div class="num">
      <p>已练习天数：<span>{{ numberInfo.total || 0 }}</span> 天</p>
      <p>截止目前连续练习天数：<span>{{ numberInfo.continuo || 0 }}</span> 天</p>
    </div>
    <div class="spinbox">
      <FullCalendar class="fullCalendar" ref="fullCalendar" :options="calendarOptions" />
      <div class="msg">
        <p><span></span>已练习</p>
        <p><span></span>未练习</p>
      </div>
      <div class="current">
        <div v-for="item in list" :key="item.id" class="itembox">
          <div class="current-top">
            <div class="time">{{ timeFun(item.every_date) }}</div>

          </div>
          <div class="current-con">
            <div class="leftbox">
              <div class="name">{{ item.name }}</div>
              <div>得分:{{ item.exam_info ? item.exam_info.total_score : 0 }} </div>
            </div>
            <div class="rightbox">
              <Button v-if="item.exam_info && item.exam_info.total_score" type="primary"
                @click="$router.push('/dayPractice/paperLook?id=' + item.id)">试卷解析</Button>

              <Button v-else type="error">未练习</Button>
            </div>
          </div>
        </div>
        <div class="nodata" v-if="list.length == 0">暂无训练记录</div>
      </div>
      <Spin size="large" fix v-show="spinShow"></Spin>
    </div>
  </div>
</template>

<script>
  import FullCalendar from '@fullcalendar/vue'
  import dayGridPlugin from '@fullcalendar/daygrid'
  import interactionPlugin from '@fullcalendar/interaction'
  export default {
    components: { FullCalendar },
    data() {
      return {
        calendarApi: null,
        calendarOptions: {
          plugins: [dayGridPlugin, interactionPlugin], // 需要用哪个插件引入后放到这个数组里
          initialDate: new Date(), // 日历第一次加载时显示的初始日期。可以解析为Date的任何职包括ISO8601日期字符串，例如"2014-02-01"。
          initialView: 'dayGridMonth', // 日历加载时的初始视图，默认值为'dayGridMonth'，可以为任何可用视图的值，如例如'dayGridWeek'，'timeGridDay'，'listWeek'
          locale: 'zh-cn', // 设置日历的语言，中文为 “zh-cn”
          firstDay: '1', // 设置每周的第一天，默认值取决于当前语言环境，该值为代表星期几的数字，且值必须为整数，星期日=0
          weekNumberCalculation: 'ISO', // 指定"ISO"结果为ISO8601周数。指定"ISO"将firstDay的默认值更改为1（Monday）
          buttonText: { // 文本将显示在headerToolbar / footerToolbar的按钮上。不支持HTML注入。所有特殊字符将被转义。
            today: '今天',
            month: '月',
            week: '周',
            day: '天'
          },
          headerToolbar: { // 在日历顶部定义按钮和标题。将headerToolbar选项设置为false不会显示任何标题工具栏。可以为对象提供属性start/center/end或left/center/right。这些属性包含带有逗号/空格分隔值的字符串。用逗号分隔的值将相邻显示。用空格分隔的值之间会显示一个很小的间隙。
            left: false,//'dayGridMonth,dayGridWeek,dayGridDay'
            center: 'title',
            right: 'today prevYear,prev,next,nextYear',
          },
          eventTimeFormat: {  // 在每个事件上显示的时间的格式
            hour: 'numeric',
            minute: '2-digit',
            hour12: false
          },
          events: [ // 将在日历上显示的事件对象， events 可以是数组、json、函数。具体可以查看官方文档
            // title: '标题',
            // start: '事件开始事件',
            // end: '', // 这里要注意，end为可选参数，无end参数时该事件仅在当天展示
            // backgroundColor: '#FDEBC9', // 该事件的背景颜色
            // borderColor: '#FDEBC9', // 该事件的边框颜色
            // textColor: '#F9AE26' // 该事件的文字颜色
          ],
          customButtons: { // 定义可在headerToolbar / footerToolbar中使用的自定义按钮
            today: {
              text: '今天', // 按钮的展示文本
              click: this.todayClick // 点击按钮触发的事件，这里要注意的是当按钮绑定了事件之后该按钮原本自带的事件将会失效
            },
            nextYear: {
              click: this.nextYearClick
            },
            next: {
              click: this.nextClick
            },
            prev: {
              click: this.prevClick
            },
            prevYear: {
              click: this.prevYearClick
            }
          },
          eventClick: this.handleDateClick, // 点击事件时，触发该回调
          dateClick: this.handleDateClick, // 当用户单击日期或时间时,触发该回调，触发此回调，您必须加载interaction插件
        },
        newdate: new Date().Format('yyyy-MM-dd'),
        months: new Date().Format('yyyy-MM'),
        userInfo: {},
        list: [],
        spinShow: false,
        numberInfo: {}
      }
    },
    watch: {},
    created() { },
    mounted() {
      // 这里有两点要注意，想要调用插件的方法，要在组件上设置ref
      // 并且在组件未加载的时候this.$refs中是没有fullCalendar的，所以未加载的时候调用方法会报错
      this.calendarApi = this.$refs.fullCalendar.getApi()
      this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      this.getTotal(this.months)
      this.getList(this.newdate)
      this.getNumber()
    },
    methods: {
      handleDateClick(dateClickInfo) {
        // 日期格子提供 dateStr，练习链接提供 event.startStr。
        const dateStr = dateClickInfo.dateStr || (dateClickInfo.event && dateClickInfo.event.startStr)
        if (!dateStr) return
        this.list = []
        this.getList(dateStr.split('T')[0])
      },
      todayClick() {
        this.list = []
        this.calendarApi.today() // 将日历移动到当前日期。
        this.calendarApi.getDate() // 返回日期的日历的当前日期
        this.getList(this.calendarApi.getDate().Format('yyyy-MM-dd'))
      },
      nextYearClick() {
        this.calendarApi.nextYear()
        this.list = []
        this.getTotal(this.calendarApi.getDate().Format('yyyy-MM'))
      },
      prevYearClick() {
        this.calendarApi.prevYear()
        this.list = []
        this.getTotal(this.calendarApi.getDate().Format('yyyy-MM'))
      },
      nextClick() {
        this.calendarApi.next()
        this.list = []
        this.getTotal(this.calendarApi.getDate().Format('yyyy-MM'))
      },
      prevClick() {
        this.calendarApi.prev()
        this.list = []
        this.getTotal(this.calendarApi.getDate().Format('yyyy-MM'))
      },
      getTotal(months) {
        this.spinShow = true
        // 查询整月的每日一练安排，保留未练习的记录用于显示红色日历事件。
        this.$axios.get('/app/examination/index', { type: 4, months, page: 1, pageSize: 999 }).then(res => {
          let events = []
          res.data.data.forEach(item => {
            if (item.exam_info && item.exam_info.status) {
              events.push({
                title: item.name,
                start: item.exam_info.create_time,
                backgroundColor: '#3CB5A9', // 该事件的背景颜色
              })
            } else {
              events.push({
                title: item.name,
                start: item.every_date,
                backgroundColor: '#FF0000', // 该事件的背景颜色
              })
            }
          })
          this.calendarOptions.events = events
          setTimeout(() => {
            this.spinShow = false
          }, 1500);
        }).catch(() => {
          this.spinShow = false
        })
      },
      getList(days) {
        this.spinShow = true
        // 不传 exam_status，否则后端只返回已完成的历史记录。
        this.$axios.get('/app/examination/index', { type: 4, days }).then(res => {
          this.list = res.data.data
          setTimeout(() => {
            this.spinShow = false
          }, 1500);
        }).catch(() => {
          this.spinShow = false
        })
      },
      getNumber() {
        this.$axios.get('/app/examination/monthTotal',).then(res => {
          this.numberInfo = res.data
        }).catch(() => {
        })
      },
      timeFun(time) {
        if (time) {
          return time.split(' ')[0]
        }
        return ''
      },
    },
  }
</script>
<style lang='less' scoped>
  .indexbox {
    width: 100%;
    height: 100%;
    .num {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      padding: 0 0 10px;
      font-size: 16px;
      p {
        &:nth-child(2) {
          margin-left: 20px;
        }
        span {
          font-size: 18px;
          font-weight: 550;
        }
      }
    }
    .fullCalendar {
      width: 100%;
      height: 600px;
    }
    .msg {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      padding: 10px 0;
      p {
        font-size: 16px;
        display: flex;
        align-items: center;
        padding-right: 30px;
        span {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 5px;
        }
        &:nth-child(1) {
          span {
            background: #3CB5A9;
          }
        }
        &:nth-child(2) {
          span {
            background: #FF0000;
          }
        }
      }
    }
    .current {
      width: 100%;
      padding: 0 10px;
      margin-bottom: 15px;
      background: #fff;
      .itembox {
        width: 100%;
        border: 1px solid #eee;
        border-top: 5px solid #2d8cf0;
        border-radius: 8px;
        color: #222;
        margin-bottom: 15px;
        .current-top {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px;
          border-bottom: 1px solid #eee;
          .time {
            font-size: 18px;
            font-weight: 600;
          }
        }
        .current-con {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 20px;
          .leftbox {
            flex: 1;
            .name {
              font-size: 16px;
              font-weight: 600;
              margin-bottom: 3px;
            }
            >div {
              width: 100%;
              font-size: 15px;
            }
          }
          .rightbox {
            text-align: center;
            padding: 5px;
            img {
              width: 80px;
              height: 65px;
              object-fit: contain;
            }
          }
        }
      }
    }
    .nodata {
      width: 100%;
      padding: 10px 0;
      font-size: 16px;
      color: #222;
    }
    .spinbox {
      position: relative;
    }
  }
</style>
